import { date } from '@ipfabric/utils';

if (typeof DataTransfer.prototype.setDragImage !== 'function') {
  DataTransfer.prototype.setDragImage = (image, _offsetX, _offsetY) => {
    // generate a random class name that will be added to the element
    const randomDraggingClassName = `setdragimage-ie-dragging-${Math.round(Math.random() * Math.pow(10, 5))}-${date.getTs()}`;

    // prepare the rules for the random class
    const dragStylesCSS = [
      `.${randomDraggingClassName}`,
      '{',
      `background: url("${image.src}") no-repeat #fff 0 0 !important;`,
      `width: ${image.width}px !important;`,
      `height: ${image.height}px !important;`,
      'text-indent: -9999px !important;',
      'border: 0 !important;',
      'outline: 0 !important;',
      '}',
      `.${randomDraggingClassName} * {`,
      'display: none !important;',
      '}',
    ];
    // create the element and add it to the head of the page
    const dragStylesEl = document.createElement('style');
    dragStylesEl.innerText = dragStylesCSS.join('');
    const headEl = document.getElementsByTagName('head')[0];
    headEl.appendChild(dragStylesEl);

    /*
        since we can't get the target element over which the drag start event occurred
        (because the `this` represents the DataTransfer object and not the element),
        we will walk through the parents of the current functions until we find one
        whose first argument is a drag event
         */
    let parentFn = DataTransfer.prototype.setDragImage.caller;
    while (!(parentFn.arguments[0] instanceof DragEvent)) {
      parentFn = parentFn.caller;
    }

    // then, we get the target element from the event (event.target)
    const eventTarget = parentFn.arguments[0].target;
    // and add the class we prepared to it
    eventTarget.classList.add(randomDraggingClassName);

    /* immediately after adding the class, we remove it. in this way the browser will
        have time to make a snapshot and use it just so it looks like the drag element */
    setTimeout(() => {
      // remove the styles
      headEl.removeChild(dragStylesEl);
      // remove the class
      eventTarget.classList.remove(randomDraggingClassName);
    }, 0);
  };
}
